export * from './singleProperty';
